import React from 'react';
import { Content, Pen, Cancel } from './styles/StyledMoreOptions';
import { IconCancel, IconPen } from '~/presentation/base/icons';

interface ownProps {
  actionDelete?: () => any;
  actionEdit?: () => any;
}

const MoreOptions: React.FC<ownProps> = ({ actionDelete, actionEdit }) => {
  return (
    <Content>
      <Pen onClick={actionEdit!}>
        <IconPen id="btn_edit" />
      </Pen>
      <Cancel onClick={actionDelete!}>
        <IconCancel id="btn_delete" />
      </Cancel>
    </Content>
  );
};

export default MoreOptions;
